export type FeatureFlags = {
  exampleFlag?: boolean;
  enablePublicCompanyProfile?: boolean;
};

export const defaultFlags: FeatureFlags = {
  exampleFlag: false,
  enablePublicCompanyProfile: true
};
